const $ = window.jQuery

$(() => {
  $('.colorbox--blue .button').addClass('button--dark').removeClass('button--wide')
  $('.colorbox--buttonfix .button').removeClass('button--wide')
})
